/*! single-slide swiper, dots only */
(function () {
  function init() {
    const root = document.getElementById('custom-layout-swiper');
    if (!root || typeof Swiper === 'undefined') return;

    new Swiper(root, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 12,
      centeredSlides: false,
      watchSlidesProgress: true,
      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: false
      },
      pagination: {
        el: root.querySelector('.swiper-pagination'),
        clickable: true
      },
      // 允许键盘操作
      keyboard: { enabled: true },
      // 辅助无障碍标签
      a11y: {
        enabled: true,
        paginationBulletMessage: 'Go to slide {{index}}'
      }
    });
  }

  if ('requestIdleCallback' in window)
    requestIdleCallback(init, { timeout: 1500 });
  else if (document.readyState === 'complete')
    init();
  else
    window.addEventListener('load', init, { once: true });
})();
